<template>
  <v-combobox
    :value="value"
    :items="icons"
    hide-no-data
    hide-selected
    label="Google Fonts Icons"
    hint="fonts.google.com/icons"
    persistent-hint
    :prepend-inner-icon="value"
    @input="newValue => $emit('input', newValue)"
  >
    <template v-slot:item="{item}">
      <v-icon left>{{item}}</v-icon>
      {{item}}
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'iconSelector',
  props: {
    value: {type: String, required: true},
  },
  data: () => ({
    icons: [
      'analytics',
      'share',
      'local_activity',
      'assignment_turned_in',
      'developer_board',
      'pending_actions',
      'assignment_late',
      'leaderboard',
      'gavel',
      'euro_symbol',
      'account_balance',
      'shopping_cart',
      'lightbulb'
    ]
  })
}
</script>

<style>

</style>